import React from "react";
import PropTypes from "prop-types";
import Thumbnail from "./Thumbnail";
import InvalidThumbnail from "./InvalidThumbnail";
import { generateThumbnailUrl } from "../../utils/thumbnailHelpers";

export default function ThumbnailContainer(props) {
	const { thumbnailId, width, height, title } = props;
	const hasDataForUrl = thumbnailId && width && height;

	/**
	 * @todo This should be smarter - i.e. render invalid thumbnail if the request throws an error, not just if its missing a prop
	 */
	return hasDataForUrl ? (
		<Thumbnail
			width={width}
			height={height}
			imageUrl={generateThumbnailUrl(thumbnailId, width, height)}
			title={title}
		/>
	) : (
		<InvalidThumbnail width={width} height={height}/>
	);
}

ThumbnailContainer.propTypes = {
	id: PropTypes.string,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	title: PropTypes.string
};
